import {appUrl} from '@frontend/AppUrl'
import {LocalStorage} from '@frontend/services/LocalStorage'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import type {
    AdCategory,
    FilteredItemsPageUrlQueryParams,
    ItemsCategoryOrLocationForBreadcrumbs,
} from '../modules/public/ads/AdsModuleTypes'

// Собрать URL к списку объявлений или услуг (в зависимости от category).
export function makeItemsListUrl(
    category: null | Pick<AdCategory, 'id' | 'slug' | 'slugWithId' | 'type'> | ItemsCategoryOrLocationForBreadcrumbs,
    queryArgs: Partial<FilteredItemsPageUrlQueryParams> = {}
): string {
    // Если queryArgs.location не задан, то используется локация из LocalStorage.
    if (!('location' in queryArgs)) {
        queryArgs.location = LocalStorage.getFilterLocation()
    } else if (
        !queryArgs.location
        || String(queryArgs.location).trim() === ''
        || String(queryArgs.location) === '0'
    ) {
        // Удаляем из queryArgs.location, если это 0 или пустая строка.
        delete queryArgs.location
    }

    if (!category) {
        return NavigationService.makeUrl(appUrl().ads.all, null, queryArgs, true)
    }

    if ('breadcrumbType' in category && category.breadcrumbType === 'location') {
        // Передан объект AdsCategoryOrLocationForBreadcrumbs с type = 'location'.
        queryArgs.location = String(category.id)
        return NavigationService.makeUrl(appUrl().ads.all, null, queryArgs, true)
    }

    // Категория услуг.
    if (category.type === 'services') {
        return NavigationService.makeUrl(
            category.slugWithId === '' ? appUrl().services.index : appUrl().services.category,
            {
                id: category.id,
                slug: category.slug,
                slugWithId: category.slugWithId,
            },
            queryArgs,
            true
        )
    }

    // Категория объявлений.Q
    return NavigationService.makeUrl(
        appUrl().ads.category,
        {
            id: category.id,
            slug: category.slug,
            slugWithId: category.slugWithId,
        },
        queryArgs,
        true
    )
}
